/**
 * Shared label formatting utilities for chart axis labels and tooltips.
 */

/**
 * Truncate text to a maximum character count, appending an ellipsis if needed.
 * Returns the original text if it fits within maxChars.
 */
export function truncateLabel(text: string, maxChars: number = 28): string {
  if (!text || text.length <= maxChars) return text;
  return text.slice(0, maxChars - 1) + '…';
}
